import { render, staticRenderFns } from "./AmenityCard.vue?vue&type=template&id=3cbb0823&"
import script from "./AmenityCard.vue?vue&type=script&lang=js&"
export * from "./AmenityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports